/**
 * react-type-animation
 * https://react-type-animation.netlify.app/examples
 */
import { TypeAnimation } from 'react-type-animation';

document.addEventListener('DOMContentLoaded', () => {

    if (!TypeAnimation) {
        console.warn('TypeAnimation module has not been loaded.');
        return;
    }

    document.querySelectorAll('.type-animation-text').forEach(element => {

        const sequencesString = element.getAttribute('data-sequences');
        const speed = parseInt(element.getAttribute('data-speed'), 10) || 50;
        const deletionSpeed = parseInt(element.getAttribute('data-deletionSpeed'), 10) || 50;
        const omitDeletionAnimation = element.getAttribute('data-omitDeletionAnimation') === 'true' ? true : false;
        const repeat = element.getAttribute('data-repeat') === 'Infinity' ? Infinity : parseInt(element.getAttribute('data-repeat'), 10) || 0;
        const cursor = element.getAttribute('data-cursor') === 'false' ? false : true;
        const spy = element.getAttribute('data-spy');

        if (sequencesString) {
            try {
                const sequences = JSON.parse(sequencesString);
                
                // sequences가 빈 배열인지 확인
                if (!Array.isArray(sequences) || sequences.length === 0) {
                    console.warn('The animation data is invalid.');
                    return;
                }

                // sequences가 올바른 형식인지 확인
                const flattenedSequences = sequences.flat();
                if (flattenedSequences.length === 0) {
                    console.warn('The animation sequence is empty.');
                    return;
                }

                // spy가 true일 때만 Intersection Observer를 설정
                if (spy != 'false') {
                    // Intersection Observer 설정
                    const observer = new IntersectionObserver((entries) => {
                        entries.forEach(entry => {
                            if (entry.isIntersecting) {
                                // 요소가 화면에 보이면 애니메이션을 시작합니다.
                                ReactDOM.render(
                                    <TypeAnimation
                                        sequence={flattenedSequences}
                                        speed={speed}
                                        deletionSpeed={deletionSpeed}
                                        omitDeletionAnimation={omitDeletionAnimation}
                                        repeat={repeat}
                                        cursor={cursor}
                                    />,
                                    element
                                );
                            } else {
                                // 요소가 화면을 벗어나면 애니메이션을 멈춥니다.
                                ReactDOM.unmountComponentAtNode(element);
                            }
                        });
                    });

                    // Observer를 대상 요소에 추가
                    observer.observe(element);
                } else {
                    // spy가 false인 경우, 바로 애니메이션을 실행
                    ReactDOM.render(
                        <TypeAnimation
                            sequence={flattenedSequences}
                            speed={speed}
                            deletionSpeed={deletionSpeed}
                            omitDeletionAnimation={omitDeletionAnimation}
                            repeat={repeat}
                            cursor={cursor}
                        />,
                        element
                    );
                }
                
            } catch (error) {
                console.error('Animated Initialization Error:', error);
            }
        }
    });
});